// extracted by mini-css-extract-plugin
module.exports = {"products":"products_products_22Lxz","title":"products_title_2-tj7","table":"products_table_37DIL"};